// extracted by mini-css-extract-plugin
export default {"textS":"textS_textS__PpSSp"};